var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "29px",
    viewBox: "0 0 32 29",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "WarningIcon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "WarningIcon",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-2.000000, -3.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.6147266,4.64840286 L33.4851842,27.5292163 C34.2974756,28.9732899 33.7853149,30.8024352 32.3412413,31.6147266 C31.8921963,31.8673144 31.3856681,32 30.8704575,32 L5.12954245,32 C3.4726882,32 2.12954245,30.6568542 2.12954245,29 C2.12954245,28.4847894 2.26222807,27.9782612 2.51481584,27.5292163 L15.3852734,4.64840286 C16.1975648,3.20432923 18.0267101,2.69216855 19.4707837,3.50445997 C19.9496572,3.7738263 20.3453603,4.1695294 20.6147266,4.64840286 Z",
    id: "Triangle-2",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("text", {
    id: "!",
    fontFamily: "OpenSans-Bold, Open Sans",
    fontSize: 22,
    fontWeight: "bold",
    fill: "#FF0036",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 15,
    y: 27
  }, "!"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIconWhite);
export default __webpack_public_path__ + "static/media/WarningIconWhite.78b519b3601e356bd5fe4237ab49604f.svg";
export { ForwardRef as ReactComponent };